export const get_money_transitions = `query get_money_transitions($paginator: Paginator!, $order: ListingOrder!, $filter: ListingFilter!){
    get_money_transitions(paginator: $paginator, order: $order, filter: $filter){
        money_transitions{
            transaction_code
            status
            from_account
            to_account
            amount
            currency
            transfer_date
            fulfillment_date
        }
        page
        page_count
    }
}`;
